(function () {
  var MOBILE_MQ = window.matchMedia('(max-width: 1023px)');

  function isMobile() {
    return MOBILE_MQ.matches;
  }

  function setAccordionState(accordion, open) {
    var trigger = accordion.querySelector('.vf-footer-accordion__trigger');
    if (!trigger) return;

    accordion.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function closeAllAccordions(except) {
    document.querySelectorAll('[data-vf-footer-accordion]').forEach(function (accordion) {
      if (accordion !== except) {
        setAccordionState(accordion, false);
      }
    });
  }

  function resetForViewport() {
    document.querySelectorAll('[data-vf-footer-accordion]').forEach(function (accordion) {
      setAccordionState(accordion, false);
    });
  }

  function initFooterAccordions() {
    document.querySelectorAll('[data-vf-footer-accordion]').forEach(function (accordion) {
      var trigger = accordion.querySelector('.vf-footer-accordion__trigger');
      if (!trigger || trigger.dataset.vfFooterBound === 'true') return;

      trigger.dataset.vfFooterBound = 'true';
      trigger.addEventListener('click', function () {
        if (!isMobile()) return;

        var willOpen = !accordion.classList.contains('is-open');

        if (willOpen) {
          closeAllAccordions(accordion);
        }

        setAccordionState(accordion, willOpen);
      });
    });

    resetForViewport();
  }

  if (typeof MOBILE_MQ.addEventListener === 'function') {
    MOBILE_MQ.addEventListener('change', resetForViewport);
  } else if (typeof MOBILE_MQ.addListener === 'function') {
    MOBILE_MQ.addListener(resetForViewport);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFooterAccordions);
  } else {
    initFooterAccordions();
  }
})();
